// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tips-text[data-v-b9c0a734] {\n  font-size: small;\n}\n", ""]);
// Exports
module.exports = exports;
